<template>
  <a-layout
    id="components-layout-demo-side"
    class="AAA"
    style="min-height: 100vh"
  >
    <!-- 左侧边栏 -->
    <a-layout-sider v-model="collapsed" collapsible class="sider" fixed>
      <div class="logo">{{ collapsed ? shortName : shopName }}</div>
      <a-menu theme="dark" :default-selected-keys="['1']" mode="inline">
        <template v-for="item in rightList">
          <template v-if="!item.children">
            <a-menu-item :key="item.name" @click="topage(`/home/${item.path}`)">
              <!-- <a-icon :type="item.icon" /> -->
              <span>{{ item.name }}</span>
            </a-menu-item>
          </template>

          <template v-else>
            <a-sub-menu :title="item.name" :key="item.objId">
              <a-menu-item
                v-for="k in item.children"
                :key="k.objId"
                @click="topage(`/home/${k.path}`)"
              >
                <span>{{ k.name }}</span>
              </a-menu-item>
              <!-- 二级路由 -->
              <!-- <a-menu-item key="2" @click="topage('/home/memberManagement')">
              <a-icon type="user" />
              <span>会员管理</span>
            </a-menu-item> -->
            </a-sub-menu>
          </template>
        </template>
      </a-menu>
    </a-layout-sider>

    <a-layout>
      <a-row>
        <a-col :span="24">
          <a-layout-header style="background: #fff; padding: 0" class="header">
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
            <div class="head">
              <a-dropdown>
                <img
                  src="https://img2.baidu.com/it/u=3973855039,4170930478&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500"
                  alt=""
                />
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  Hover me <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a href="javascript:;" @click="clear">退出登录</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <span class="name">{{ shopName + roleName }}</span>
            </div>
            <div></div> </a-layout-header
          > </a-col
        >
      </a-row>
      <a-row type="flex">
        <a-col :span="24"> <router-view class="main"></router-view></a-col>
      </a-row>

      <!-- <a-layout-footer style="text-align: center">
        Ant Design ©2018 Created by Ant UED
      </a-layout-footer> -->
    </a-layout>
  </a-layout>
</template>
<script>
import { message } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      collapsed: false,
      // menuList: [
      //   { name: "首页" },
      //   { name: "会员管理" },
      //   { name: "轮播图管理" },
      //   {
      //     name: "门店分类",
      //     children: [{ name: 门店列表 }, { name: 门店分类 }],
      //   },
      // ],
      rightList: [],
      headImg: "",
      roleName: "",
      shopName: "",
      shortNmae: "",
    };
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    clear() {
      this.$router.go({ name: "login" });
      sessionStorage.clear();
      message.success("退出成功");
    },
  },
  created() {
    this.headImg = sessionStorage.getItem("headImg");
    this.roleName = sessionStorage.getItem("roleName") || "管理员";
    this.rightList = JSON.parse(sessionStorage.getItem("menudata"));
    this.shopName = sessionStorage.getItem("shopName");
    if (this.shopName == "undefined" || this.shopName == null || this.shopName == "") {
      this.shopName = "八达管理后台";
    }
    this.shortName = this.shopName.slice(0, 2);
    // 初始化menulist菜单栏的数据
    // this.menulist = this.rightList
    // 将有子选项的和没子选项的筛选一下 有子选项的赋值给menulist 没有子选项的赋值给itemlist
    // for (var i = 0, j = 0, k = 0; i < this.rightList.length; i++) {
    //   // console.log(this.rightList[i].children.length)
    //   if (this.rightList[i].children.length !== 0) {
    //     this.menulist[j] = this.rightList[i];
    //     j = j + 1;
    //   } else {
    //     this.itemlist[k] = this.rightList[i];
    //     k = k + 1;
    //   }
    // }
  },
  computed: {
    // ...mapState(["rightList"]),
  },
};
</script>
<style lang="sass" scoped>
.name
  position: relative
  left: 600px

img
  border-radius: 50%
  width: 50px
  height: 50px
  position: relative
  left: 600px

.sider
  height: 100vh
  overflow-y: auto
  margin-bottom: 43px

  &::-webkit-scrollbar
    display: none

.header
  position: fixed
  display: flex
  justify-content: space-between
  align-items: center
  width: 100vw
  z-index: 5

.main
  position: relative
  top: 66px
  height: 100vh
  overflow-y: auto

  &::-webkit-scrollbar
    display: none

#components-layout-demo-side .logo
  color: #fff
  text-align: center
  line-height: 32px
  font-size: 19px
  height: 32px
  /* background: rgba(255, 255, 255, 0.2); */
  margin: 16px

#components-layout-demo-side .trigger
  font-size: 18px
  line-height: 64px
  padding: 0 24px
  cursor: pointer
  transition: color 0.3s

  &:hover
    color: #1890ff
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue